import {
  LayoutDashboard, Users, UserPlus, Settings, FileText,
  UserCog, LogOut, User, DollarSign, Calculator, Sliders,
  UserCheck, Search, Target, ClipboardList, TrendingUp, Grid3X3,
  GraduationCap, Calendar, FileSignature, FileText as FileContract,
  MessageSquare, QrCode, Mail, Filter, ChevronLeft, ChevronRight,
  Menu, Shield, Bot, FolderPlus, ChevronDown, ChevronUp, Tags,
  Building, Briefcase, MapPin, BarChart3, MessageCircle, Activity,
  Users2, Star, PieChart, ClipboardCheck, BookOpen, Layers,
  Link as LinkIcon, Clock, Brain, Heart, Award, Zap, Rocket,
  Sparkles, Plug, ListChecks, Smartphone, Cake, KeyRound
} from "lucide-react";

export const iconMap = {
  KeyRound,
  LayoutDashboard,
  Users,
  UserPlus,
  Settings,
  FileText,
  UserCog,
  LogOut,
  User,
  DollarSign,
  Calculator,
  Sliders,
  UserCheck,
  Search,
  Target,
  ClipboardList,
  TrendingUp,
  Grid3X3,
  GraduationCap,
  Calendar,
  FileSignature,
  FileContract,
  MessageSquare,
  QrCode,
  Mail,
  Filter,
  ChevronLeft,
  ChevronRight,
  Menu,
  Shield,
  Bot,
  FolderPlus,
  ChevronDown,
  ChevronUp,
  Tags,
  Building,
  Briefcase,
  MapPin,
  BarChart3,
  MessageCircle,
  Activity,
  Users2,
  Star,
  PieChart,
  ClipboardCheck,
  BookOpen,
  Layers,
  LinkIcon,
  Clock,
  Brain,
  Heart,
  Award,
  Zap,
  Rocket,
  Sparkles,
  Plug,
  ListChecks,
  Smartphone,
  Cake,
};
